export default __webpack_public_path__ + "static/media/property_355.c04372fc.png";